import gsap from 'gsap';
import { CustomEase } from "gsap/CustomEase";

gsap.registerPlugin(CustomEase);
gsap.defaults({ease: 'linear'});

class AiSceneHero {
  constructor(el) {
    this.el = el;
    this.timer = null;
    this.timerTime = 3000;
    this.init()
  }

  init() {
    this.currentTransitionSpeed = 1400;
    this.activeIndex = 0;
    this.slides = this.el.querySelectorAll('.ai-slide');

    this.startTimer();
  }

  slideNext() {
    let nextIndex = this.activeIndex + 1;
    if(nextIndex > this.slides.length - 1) {
        nextIndex = 0;
    }

    const prevIndex = this.activeIndex;

    gsap.to(this.slides[nextIndex], {
        duration: this.currentTransitionSpeed / 1000,
        opacity: 1,

        onStart: () => {
            gsap.set(this.slides[prevIndex], {
                zIndex: 1
            });
            gsap.set(this.slides[nextIndex], {
                zIndex: 2
            });
        },

        onComplete: () => {
            gsap.set(this.slides[prevIndex], {
                zIndex: 1,
                opacity: 0
            });

            this.activeIndex = nextIndex;
            this.startTimer();
        }
    });
  }

  startTimer() {
    this.timer = setTimeout(() => {
      this.slideNext();
    }, this.timerTime);
  }
}

export default AiSceneHero;
